import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { DynamicTableV2ColumnOptionDialogComponent } from './dynamic-table-v2-column-option-dialog/dynamic-table-v2-column-option-dialog.component';

@Component({
	selector: 'app-dynamic-table-v2',
	templateUrl: './dynamic-table-v2.component.html',
	styleUrls: ['./dynamic-table-v2.component.scss'],
})
export class DynamicTableV2Component implements AfterViewInit, OnChanges {
	@ViewChild('dataTable') table: MatTable<any>;
	@ViewChild(MatSort) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@Input() elements: any[];
	@Input() columns: any[];
	@Input() pageSizeOptions: any[];
	@Input() module: string;
	@Input() elementLinkPostfix = '';
	@Input() haveLink = true;
	@Output() filtersClicked = new EventEmitter();
	@Output() buttonClicked = new EventEmitter();
	@Output() filtersChanged = new EventEmitter();
	protected tableShowOptions = false;
	protected filterValue: string;
	matData = new MatTableDataSource<any>();
	viewIsSet = false;
	showColumns: string[] = [];
	settings = {
		hiddenColumns: [],
		size: null,
	};
	tableKeys: string[];

	constructor(public dialog: MatDialog) {}

	ngAfterViewInit() {
		this.matData.sort = this.sort;
		this.matData.paginator = this.paginator;
		this.paginator._intl.itemsPerPageLabel = 'Pozycji na stronie: ';
		this.paginator._intl.lastPageLabel = 'Ostatnia strona';
		this.paginator._intl.firstPageLabel = 'Pierwsza strona';
		this.paginator._intl.nextPageLabel = 'Następna strona';
		this.paginator._intl.previousPageLabel = 'Poprzednia strona';
	}

	ngOnChanges(): void {
		if (!this.elements) {
			return;
		}
		this.loadData();
	}

	protected loadData(): void {
		this.matData.data = this.elements.map((obj) => {
			const row = {
				class: null,
				style: null,
				link: null,
				tableElementId: null,
				id: null,
			};
			this.columns.forEach((column) => {
				if (this.settings.hiddenColumns.includes(column.col)) {
					return;
				}
				row[column.col] = obj[column.col];
			});
			row.link = '/' + this.module + '/' + obj.id + '/' + this.elementLinkPostfix;
			row.tableElementId = 'tableElement-' + obj.id;
			row.id = obj.id;
			return row;
		});
		this.convertData(this.matData.data);
	}

	protected convertData(data) {
		this.tableKeys = this.columns.map((obj) => obj.col);
		this.tableKeys.push('columnShow');
		this.matData.data = data;
		this.settingsLoad();
		this.generateColumns();
	}
	private settingsLoad(): void {
		if (!localStorage['pageSettings-' + this.module]) {
			return;
		}
		this.settings = JSON.parse(localStorage['pageSettings-' + this.module]);
		this.viewIsSet = !!(this.settings.hiddenColumns && this.settings.hiddenColumns.length);
	}

	protected generateColumns(): void {
		this.showColumns = this.tableKeys.filter((obj) => !this.settings.hiddenColumns.includes(obj));
		this.setTableSize();
	}

	private setTableSize(): void {
		if (!this.settings.size) return;
		const elements = ['mat-table', 'mat-paginator'];
		elements.forEach((elementId) => {
			const element = document.getElementById(elementId);

			if (!element) {
				return;
			}

			element.style.width = this.settings.size + 'px';
		});
	}

	removeDuplicates(obj) {
		return [...new Set(obj)];
	}

	protected isArray(obj: any) {
		return Array.isArray(obj);
	}

	filtersOpen(): void {
		this.filtersClicked.emit(true);
	}

	protected openDialog(): void {
		const dialogRef = this.dialog.open(DynamicTableV2ColumnOptionDialogComponent, {
			data: {
				module: this.module,
				settings: this.settings,
				columns: this.columns,
			},
		});
		const sub = dialogRef.componentInstance.columnChanged.subscribe((result) => {
			this.settings.hiddenColumns = result.hiddenColumns;
			this.generateColumns();
		});
		dialogRef.afterClosed().subscribe((result) => {
			sub.unsubscribe();
		});
	}

	refreshFilter(): void {
		if (this.filterValue.length < 3 && this.filterValue.length > 0) {
			return;
		}
		this.matData.filter = this.filterValue.trim().toLowerCase();
	}
}
